import React from "react";
import LottieView from "lottie-react-native";
import { StyleSheet, Text, View } from "react-native";

import { useAppContext } from "../../Universal/API/Context-API/AppContext";
import { webFont } from "../../Universal/API/API";

interface NothingFoundProps {
  query?: string;
}

const createStyles = (scaleAll: number, isSmallVersion: boolean) =>
  StyleSheet.create({
    wrap: {
      width: "100%",
      alignItems: "center",
      paddingHorizontal: 16 * scaleAll,
      paddingBottom: 36 * scaleAll,
    },
    shell: {
      width: "100%",
      maxWidth: 920 * scaleAll,
    },
    card: {
      borderRadius: 30 * scaleAll,
      backgroundColor: "#FBFBFA",
      borderWidth: 1,
      borderColor: "#ECE8E1",
      paddingHorizontal: 24 * scaleAll,
      paddingTop: 24 * scaleAll,
      paddingBottom: 26 * scaleAll,
      alignItems: "center",
    },
    animationWrap: {
      width: isSmallVersion ? 220 * scaleAll : 300 * scaleAll,
      height: isSmallVersion ? 220 * scaleAll : 300 * scaleAll,
      marginBottom: 8 * scaleAll,
    },
    title: {
      fontFamily: webFont("Inter"),
      fontSize: isSmallVersion ? 18 * scaleAll : 22 * scaleAll,
      lineHeight: isSmallVersion ? 24 * scaleAll : 28 * scaleAll,
      color: "#111111",
      fontWeight: "700",
      textAlign: "center",
      marginBottom: 10 * scaleAll,
    },
    text: {
      fontFamily: webFont("Inter"),
      fontSize: 14 * scaleAll,
      lineHeight: 22 * scaleAll,
      color: "#6F6A63",
      fontWeight: "500",
      textAlign: "center",
      maxWidth: 560 * scaleAll,
    },
    queryChip: {
      marginTop: 14 * scaleAll,
      minHeight: 40 * scaleAll,
      borderRadius: 999,
      paddingHorizontal: 14 * scaleAll,
      paddingVertical: 7 * scaleAll,
      backgroundColor: "#F4F1EB",
      borderWidth: 1,
      borderColor: "#E6E1D8",
      justifyContent: "center",
    },
    queryText: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "#5C554D",
      fontWeight: "700",
      textAlign: "center",
    },
  });

const NothingFound: React.FC<NothingFoundProps> = ({ query }) => {
  const { isSmallVersion, scaleAll } = useAppContext();
  const styles = React.useMemo(() => createStyles(scaleAll, isSmallVersion), [isSmallVersion, scaleAll]);

  return (
    <View style={styles.wrap}>
      <View style={styles.shell}>
        <View style={styles.card}>
          <View style={styles.animationWrap}>
            <LottieView
              source={require("./NothingFound.json")}
              autoPlay
              loop={false}
              style={{ width: "100%", height: "100%" }}
              webStyle={{ width: "100%", height: "100%" }}
            />
          </View>

          <Text selectable={false} style={styles.title}>
            Ничего не найдено
          </Text>

          <Text selectable={false} style={styles.text}>
            Попробуйте ввести артикул, название коллекции или сократить запрос, чтобы получить более точные результаты.
          </Text>

          {query ? (
            <View style={styles.queryChip}>
              <Text selectable={false} style={styles.queryText}>
                {`Запрос: ${query}`}
              </Text>
            </View>
          ) : null}
        </View>
      </View>
    </View>
  );
};

export default React.memo(NothingFound);
